<template>
  <BaseDialog
        :showDialog="showDialog"
        headline="lang_GENERIC_ACTION_OPTION_CAPTION_LAUNCH_STATEMENT_PREVIEW"
        :close="closeDialog"
        :alvqa="alvqa"
        maxCardHeight="600"
        maxDialogWidth="700"
    >
        <template v-slot:headerActions>
            <span v-if="context === 'PublishingStatements' && hasContextHelp" class="mt-3">
                <ContextHelpIcon 
                    context="PublishingStatementsMappingExport" 
                    :alvqa="alvqa + '-context-help-icon'"
                />
            </span>
        </template>
        <template v-slot:dialogText>
            <v-container fluid >
                <v-row style="background-color: var(--v-listPageHeadlineBackground-base);">
                    <v-col 
                        class="headline"
                        :alvqa="alvqa + '-dialog-title'"
                    >
                            <BaseEditPageDatePicker 
                            :context="context + 'StatementPreviewDialog'"
                            :clearable="false"
                            field="StatementPreviewDate"
                            :label="$t('lang_GENERIC_CAPTION_STATEMENT_CREATION_DATE')"  
                            :disabled="false"
                            :alvqa="alvqa + '-datepicker-statement-date'"
                        />
                    </v-col>
                </v-row>
                <v-row class="ml-4">  
                    <v-col class="pl-0">
                       <BaseCheckbox 
                            :context="context + 'StatementPreviewDialogCreatePdf'"
                            :label="$t('lang_PUBLISHING_STATEMENTS_ACTION_STATEMENT_PREVIEW_DIALOG_OPTIMIZE_PROCESSING_CHECKBOX')" 
                            :value="true"
                            hideDetails
                            class="mt-0"
                            :iconTooltipText="$t('lang_PUBLISHING_STATEMENTS_ACTION_STATEMENT_PREVIEW_DIALOG_OPTIMIZE_PROCESSING_CHECKBOX_TOOLTIP_TEXT')"
                            :alvqa="alvqa + '-excel-checkbox-create-pdf'"
                        />
                    </v-col>
                </v-row>
                <!-- C3 checkbox removed from UI but value still sent via store in start() -->
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-container fluid>
                <v-row>
                    <v-spacer />
                    <v-col class="text-right" align-self="center">
                        <span>
                            <BaseButton 
                                :disabled="isStarting"
                                :label="getButtonLabel"
                                @click="start"
                                :alvqa="alvqa + '-button-archiving'"
                            />
                        </span>
                    </v-col>
                </v-row>
            </v-container>
        </template>
       </BaseDialog>
</template> 
<script>

import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseCheckbox from '@/components/_base/BaseCheckbox'
import BaseTooltip from '@/components/_base/BaseTooltip'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'


export default {
    name:'StatementPreviewDialog',

    data() {
        return {
            alvqa: "statements-statement-preview-dialog",
            hasContextHelp: false,
            isStarting: false
        }
    },
    props:{
        context:String,
        dir:String
    },


    components: {
        BaseDialog,
        BaseButton,
        BaseEditPageDatePicker,
        BaseCheckbox,
        BaseTooltip,
        ContextHelpIcon
    },

    async created() {
        if (this.context === 'PublishingStatements') {
            this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('PublishingStatementsMappingExport')
        }
    },

    computed: {
        showDialog: {
            get() { return this.$store.getters.getShowStatementPreviewDialog },
            set(show) { this.$store.commit('setShowStatementPreviewDialog', show) }
        },        
        selectedPreviewDate: {
            get() { return this.$store.getters["get" + this.context + "StatementPreviewDialogDetailsStatementPreviewDate"] },
            set(value) { this.$store.commit("set" + this.context + "StatementPreviewDialogDetailsStatementPreviewDate", value) }
        
        },
        createPdfCheckBox: {
            get() { return this.$store.getters["get" + this.context + "StatementPreviewDialogCreatePdfCheckbox"] },
            set(value) { this.$store.commit("set" + this.context + "StatementPreviewDialogCreatePdfCheckbox", value) }
        },
        
        getButtonLabel() {
            let langConst = 'lang_BUTTON_START'
            return langConst
        }
    },

    methods: {
        closeDialog() {
            this.showDialog = false
            this.selectedPreviewDate = this.$alvPlugin.dateToISOFormat(new Date())
            //this.createPdfCheckBox = false
        },

        async start(){
            this.isStarting = true
            let selectedDate = this.$store.getters["get" + this.context + "StatementPreviewDialogDetailsStatementPreviewDate"]
            let createPdf = this.$store.getters["get" + this.context + "StatementPreviewDialogCreatePdfCheckbox"]
            let requestParams = { context: this.context, dir: this.dir,statementDate:selectedDate, createPdf:createPdf }
            if (this.context === 'PublishingStatements') {
                let c3calculation = this.$store.getters["getPublishingStatementsStatementPreviewDialogC3CalculationCheckbox"]

                requestParams['c3Calculation'] = c3calculation ? "yes" : "no"
            }

            await this.$store.dispatch('launchStatementRun', requestParams)
            this.isStarting = false
            this.closeDialog()
        }
    }
}
</script>

<style>

</style>